import { useMutation, useQuery } from "@tanstack/react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { BackArrow } from "../../components/CustomMiscellaneous/BackArrow";
import CustomButtonSimple from "../../components/CustomMiscellaneous/CustomButtonSimple";
import HorizontalRule from "../../components/HorizontalRule/HorizontalRule";
import { PropDisplay } from "../../components/PropDisplay";
import { buildEndpoint, genericGet, genericPatch } from "../../services/api.service";

export default function PedidoOrcamento() {
	const location = useLocation();
	const navigate = useNavigate();

	const {
		data: pedidoOrcamento,
		isLoading,
		refetch,
	} = useQuery({
		queryKey: ["orcamento"],
		queryFn: async () => {
			return await genericGet(location.pathname);
		},
	});

	const mutation = useMutation({
		mutationKey: ["discard"],
		mutationFn: () => genericPatch(`${location.pathname}/discard`)({}),
		onSuccess: () => {
			refetch();
		},
	});

	const stateMap = (estadoPedidoOrcamento: string) => {
		switch (estadoPedidoOrcamento) {
			case "OPEN":
				return "Aberto";
			case "PROCESSED":
				return "Processado";
			case "DISCARDED":
				return "Descartado";
			default:
				return "Desconhecido";
		}
	};

	if (isLoading) return null;

	return (
		<>
			<BackArrow onClick={() => navigate(-1)} />

			<div className="border rounded-md shadow-md p-8 px-16 text-sm m-10">
				<h2 className="font-bold text-xl mb-4">Pedido Orçamento {pedidoOrcamento.id}</h2>

				<PropDisplay prop={"Remetente"} value={pedidoOrcamento.sender} />
				<PropDisplay prop={"Destinatário"} value={pedidoOrcamento.receiver} />

				<PropDisplay prop={"Título"} value={pedidoOrcamento.title} />

				{/* <PropDisplay prop={"Conteúdo"} value={pedidoOrcamento.body} /> */}

				<div dangerouslySetInnerHTML={{ __html: pedidoOrcamento.body }} />

				<PropDisplay prop={"Estado"} value={stateMap(pedidoOrcamento.estadoPedidoOrcamento)} />

				<div className="flex items-center justify-between py-2">
					<div className="font-bold">Orçamento</div>
					{pedidoOrcamento.orcamento ? (
						<div className="text-cyan-600 font-bold hover:underline cursor-pointer" onClick={() => navigate(`/orcamentos/${pedidoOrcamento?.orcamento?.id}`)}>
							{pedidoOrcamento?.orcamento?.id}
						</div>
					) : (
						<span>-</span>
					)}
				</div>

				<HorizontalRule />
				<div className="font-bold mt-2">Anexos</div>
				<div className="pt-2">
					{pedidoOrcamento?.attachments?.map((anexo: any, idx: number) => {
						return (
							<div key={idx} className={`w-1/2 flex justify-between p-2 m-1 border border-zinc-300 rounded-md `}>
								<div className="w-fit p-1 hover:underline">
									<a href={buildEndpoint(`${location.pathname}/anexos/download/${anexo.id}`)} target="__blank">
										<span className="font-bold">{anexo.name}</span>
									</a>
								</div>
							</div>
						);
					})}
				</div>

				<div className="flex justify-end mt-5">
					{pedidoOrcamento.estadoPedidoOrcamento === "OPEN" ? <CustomButtonSimple className="mr-3 bg-red-600 hover:text-cyan-600 hover:border-cyan-600" text="Discartar" onClick={() => mutation.mutate()} /> : null}

					{pedidoOrcamento.estadoPedidoOrcamento === "OPEN" ? <CustomButtonSimple className="mr-3 bg-cyan-600 hover:text-cyan-600 hover:border-cyan-600" text="Orçamentar" onClick={() => navigate({ pathname: "/orcamentos/custom-form", search: `pedidoId=${pedidoOrcamento.id}` })} /> : null}
				</div>
			</div>
		</>
	);
}
